import Vue from "vue";
import BigNumber from 'bignumber.js'
import memoize from 'memoizee'
import { getPricesArrayForTokens } from '../utils/data/getPricesForTokens'
import getPricesForAssets from '../utils/data/getPricesForAssets'
import config from '@/constants/config'
import coins from '@/constants/coins'
import pools from '@/constants/pools'
import { IS_DEV } from '@/constants/AppConstants'
import { sum } from '@/utils/Array'
import callCryptoPoolData from '@/utils/data/callCryptoPoolData'
import { contract as currentContract, infura_url } from '../contract.js'
import { chunkArr, getDecimalsFromPow } from './helpers'
import { contractAbis, multicall_address, multicall_abi, ERC20_abi, cERC20_abi, yERC20_abi, idleERC20_abi, synthERC20_abi, liquiditygauge_v3 } from '@/constants/abis'
import * as gasPriceStore from '../components/common/gasPriceStore'
import Web3 from "web3";
import { ethers } from 'ethers';
import { getters } from '../contract'
import * as errorStore from '../components/common/errorStore'
import { notify, notifyHandler } from '../init'
import { multiCall, sendSafe } from './Calls'

import EventBus from '../components/graphs/EventBus'

const allCoins = coins;
var cBN = (val) => new BigNumber(val);

let requiresResetAllowance = ['0xdAC17F958D2ee523a2206206994597C13D831ec7', '0xC25a3A3b969415c80451098fa907EC722572917F', '0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3',
  '0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8', '0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2', '0x9fC689CCaDa600B6DF723D9E47D84d76664a1F23',
  '0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B', '0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8', '0x49849C98ae39Fff122806C06791Fa73784FB3675',
  '0xb19059ebb43466C323583928285a49f558E572Fd', '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490', '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
  '0xFE0176d292D6e2B28E14f5d1D0c9AD2F98e7f3F9', '0xb19059ebb43466C323583928285a49f558E572Fd', '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
  '0xD2967f45c4f384DEEa880F807Be904762a3DeA07', '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858', '0x97E2768e8E73511cA874545DC5Ff8067eB19B787',
  '0x4f3E8F405CF5aFC05D68142F3783bDfE13811522', '0x6D65b498cb23deAba52db31c93Da9BFFb340FB8F', '0x1AEf73d49Dedc4b1778d0706583995958Dc862e6',
  '0xC2Ee6b0334C261ED60C72f6054450b61B8f18E35', '0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd', '0x3a664Ab939FD8482048609f652f9a0B0677337B9',
  '0xDE5331AC4B3630f94853Ff322B66407e0D6331E8', '0x410e3E86ef427e30B9235497143881f717d93c2A'
]

//for some reason web3 doesnt fire confirmation events which leaves us not knowing when a trnsaction confirms
//this is hacky bit of code
export async function approve(contract, amount, account, toContract) {
  if (!toContract) toContract = currentContract.swap_address


  let estimateGas = 0

  if (config.blockchainId !== 'arbitrum') {
    let estimateGas = await contract.methods.approve(toContract, cBN(amount).toFixed(0, 1))
      .estimateGas({
        from: account,
        gas: 100000,
      })
    if (!estimateGas) {
      estimateGas = 100000;
    } else {
      estimateGas = estimateGas * 1.1;
      estimateGas = estimateGas.toFixed(0)
    }
  } else {
    estimateGas = 100000
  }


  let provider;
  provider = currentContract.provider;

  // Acccounts now exposed
  let data = contract.methods.approve(toContract, cBN(amount).toFixed(0, 1)).encodeABI()
  const params = [{
    from: account,
    to: contract._address,
    data: data
  }];

  let contractEthers;
  if (config.blocknativeSupport === true) {
    if (localStorage.getItem('selectedWallet') === 'MetaMask') {
      //breaks if no web3?
      let ethereum = window.ethereum;
      // Request account access if needed
      await ethereum.enable();
      provider = new ethers.providers.Web3Provider(ethereum);
    } else {
      provider = new ethers.providers.Web3Provider(getters.walletProvider());
    }

    var signer = provider.getSigner();
    contractEthers = new ethers.Contract(contract._address, ERC20_abi, signer);
  } else {
    contractEthers = new ethers.Contract(contract._address, ERC20_abi, currentContract.signer);
  }

  let sendTransactionPromise = await contractEthers.approve(toContract, cBN(amount).toFixed(0, 1), gasPriceStore.getGasFields()).catch((err) => {
    if (err.message.includes('EIP-1559')) {
      return contractEthers.approve(toContract, cBN(amount).toFixed(0, 1), gasPriceStore.getGasFields({ forcePreEip1559: true }));
    }

    throw err;
  });
  notifyHandler(sendTransactionPromise.hash)
  await sendTransactionPromise.wait();
}

export function approve_to_migrate(amount, account) {
  return new Promise(resolve => {
    (async () => {
      (await sendSafe(currentContract.old_swap_token.methods.approve(currentContract.migration_address, amount), {
        from: account,
        gas: 100000,
      })).pe
        .once('transactionHash', function(hash) {
          notifyHandler(hash)
          resolve(true);
        })
        .catch(err => {
          errorStore.handleError(err)
          reject(err)
        });
    })()
  });
}

export async function ensure_allowance_zap_out(amount, fromContract, toContract, infinite = false) {

  infinite = true;
  var default_account = currentContract.default_account
  if (!fromContract) fromContract = currentContract.swap_token;
  if (!toContract) toContract = contractAbis[currentContract.currentContract].deposit_address
  let allowance = cBN(await currentContract.swap_token.methods.allowance(default_account, toContract).call())
  if (!infinite) {
    if (allowance.lt(cBN(amount))) {
      if (allowance > 0) await approve(fromContract, 0, default_account, toContract)
      await approve(fromContract, amount, default_account, toContract)
    }
  }
  else {
    if (allowance.lt(currentContract.max_allowance.div(cBN(2))) && cBN(amount).gt(0)) {
      if (allowance > 0 && requiresResetAllowance.includes(fromContract._address))
        await approve(fromContract, 0, default_account, toContract)
      await approve(fromContract, currentContract.max_allowance, default_account, toContract)
    }
  }
}

export async function ensure_allowance(amounts, plain = false, contractName, N_COINS, infinite = false, swapStraightEth = undefined) {
  infinite = true;

  var default_account = currentContract.default_account
  let cont = currentContract


  if (N_COINS === undefined) {
    N_COINS = currentContract.N_COINS
  }
  if (contractName !== undefined) {
    cont = currentContract.contracts[contractName]
  }

  var allowances = new Array(N_COINS);
  let coins = currentContract.coins;
  let swap = cont.swap_address;


  if (plain) {
    coins = cont.underlying_coins;

    if (!currentContract.is_aave && !currentContract.is_new_underlying) {
      swap = contractAbis[cont.currentContract].deposit_address;
    }
  }

  if (contractAbis[cont.currentContract].is_meta) {
    coins = currentContract.all_coins
    N_COINS = contractAbis[cont.currentContract].meta_N
    if (amounts.length == 2) {
      coins = coins.filter((_, i) => i < 2)
    }


    if (amounts.length == contractAbis[cont.currentContract].meta_N - 1) {
      coins = coins.filter((_, i) => i != 1)
      //if deposit is unwrapped we make sure the address approved is the zap
      swap = contractAbis[cont.currentContract].deposit_address;
    }
  }

  const currentPool = pools.getById(cont.currentContract);
  if (currentPool.isFakePlainPool || swapStraightEth) {
    swap = (
      contractAbis[cont.currentContract].deposit_address ||
      contractAbis[cont.currentContract].swap_address
    );
  }

  let fromContract = coins
  let calls = []
  const ethCoinIndex = (swapStraightEth || (contractAbis[cont.currentContract].pool_type !== 'crypto' && cont.has_eth)) ? currentPool.coins.findIndex(({ address }) => (
    (!!config.nativeAssetErc20WrapperId && address.toLowerCase() === allCoins[config.nativeAssetErc20WrapperId].address.toLowerCase()) ||
    address.toLowerCase() === allCoins[config.nativeAssetId].address.toLowerCase()
  )) : undefined;
  for (let i = 0; i < amounts.length; i++) {
    calls.push([coins[i]._address, coins[i].methods.allowance(default_account, swap).encodeABI()])
  }

  if (swapStraightEth || (contractAbis[cont.currentContract].pool_type !== 'crypto' && cont.has_eth)) {
    calls = [...calls.slice(0, ethCoinIndex), ...calls.slice(ethCoinIndex + 1)];
  }

  let aggcalls = await currentContract.multicall.methods.aggregate(calls).call();
  allowances = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex));


  if (swapStraightEth || (contractAbis[cont.currentContract].pool_type !== 'crypto' && cont.has_eth)) {
    allowances = [
      ...allowances.slice(0, ethCoinIndex),
      cont.max_allowance,
      ...allowances.slice(ethCoinIndex),
    ];
  }

  console.log({ allowances })


  if (!infinite) {
    // Non-infinite
    for (let i = 0; i < amounts.length; i++) {
      if (cBN(allowances[i]).isLessThan(cBN(amounts[i])) && cBN(amounts[i]).gt(0)) {
        if (allowances[i] > 0 && requiresResetAllowance.includes(coins[i]._address))
          await approve(coins[i], 0, default_account, swap);
        await approve(coins[i], amounts[i], default_account, swap);
      }
    }
  }
  else {
    // Infinite
    for (let i = 0; i < amounts.length; i++) {
      if (cBN(allowances[i]).isLessThan(cBN(amounts[i])) && cBN(amounts[i]).gt(0)) {
        if (allowances[i] > 0 && requiresResetAllowance.includes(coins[i]._address))
          await approve(coins[i], 0, default_account, swap);
        await approve(coins[i], cont.max_allowance, default_account, swap);
      }
    }
  }
}

// fromCurrency is now asset id
export async function ensure_underlying_allowance(fromCurrency, _amount, toContract, wrapped = false, contract, isCryptoRouter = false) {
  if (!contract) contract = currentContract

  const currentPool = pools.getById(contract.currentContract);

  const fromCurrencyAddress = (
    (currentPool.isFactoryOnlyPool && currentPool.factoryVersion === 1) ?
      (currentPool.coins.slice(0, -1).concat(currentPool.metaCoins))[fromCurrency].address :
      (currentPool.isFactoryOnlyPool && currentPool.isMetaPool && currentPool.factoryVersion === 2) ?
        (currentPool.coins.slice(0, -1).concat(currentPool.metaCoins))[fromCurrency].address :
        (currentPool.isFactoryOnlyPool && currentPool.factoryVersion === 2) ?
          currentPool.coins[fromCurrency].address :
          coins[fromCurrency].address
  );
  if (fromCurrencyAddress.toLowerCase() === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee') {
    return false;
  }

  let coinsContracts = contractAbis[contract.currentContract].is_meta ?
    contract.all_coins : contract.underlying_coins;

  if (wrapped) coinsContracts = contract.coins
  if (contractAbis[contract.currentContract].is_meta && !wrapped) {
    coinsContracts = coinsContracts.filter((_, i) => i != 1)
  }

  var default_account = currentContract.default_account
  var amount = cBN(_amount);

  const fromCurrencyContract = (
    coinsContracts.find(({ _address }) => _address.toLowerCase() === fromCurrencyAddress.toLowerCase()) ||
    new currentContract.web3.eth.Contract(ERC20_abi, fromCurrencyAddress)
  );

  let current_allowance = (
    fromCurrency === config.nativeAssetId ?
      currentContract.max_allowance : // doesn't need an allowance
      cBN(await fromCurrencyContract.methods.allowance(default_account, (
        isCryptoRouter ? toContract :
          (currentPool.isFactoMetaPoolAndTwoLevelsDeep) ? contract.deposit_zap._address :
            (currentPool.isForexMetaPool) ? contract.deposit_zap._address :
              contract.crypto_zap ? contract.crypto_zap._address :
                contract.swap._address
      )).call())
  );
  if (currentPool.isFakePlainPool) {
    current_allowance = cBN(await fromCurrencyContract.methods.allowance(default_account, contract.crypto_zap._address).call())
    toContract = contract.crypto_zap._address
  }
  if (currentPool.isFactoMetaPoolAndTwoLevelsDeep) {
    toContract = contract.deposit_zap._address;
  }
  const isFactoCryptoMetaPool = (
    currentPool.isMetaPool &&
    currentPool.isFactoryOnlyPool &&
    currentPool.cryptoPool
  );
  if (isFactoCryptoMetaPool) {
    toContract = contract.deposit_zap._address;
  }

  if (currentPool.isForexMetaPool) {
    toContract = contract.deposit_zap._address;
  }

  if (current_allowance.gte(amount))
    return false;
  if ((cBN(_amount).isEqualTo(currentContract.max_allowance)) & (current_allowance.isGreaterThan(currentContract.max_allowance.div(cBN(2)))))
    return false;  // It does get spent slowly, but that's ok
  if ((current_allowance.isGreaterThan(cBN(0))) & (current_allowance.isLessThan(amount)) && requiresResetAllowance.includes(fromCurrencyContract._address))
    await approve(fromCurrencyContract, 0, default_account, toContract);
  return await approve(fromCurrencyContract, cBN(currentContract.max_allowance).toFixed(0, 1), default_account, toContract);
}

export async function approveAmount(contract, amount, account, toContract, infinite = false) {
  infinite = true;
  let current_allowance = cBN(await contract.methods.allowance(account, toContract).call())
  if (!infinite) {
    if (current_allowance.lt(amount) && amount.gt(0)) {
      if (current_allowance > 0 && requiresResetAllowance.includes(contract._address)) {
        await approve(contract, 0, account, toContract)
      }
      await approve(contract, amount, account, toContract)
    }
  }
  else {
    //(currentContract.max_allowance.div(cBN(2)) no need to have infinite allowance if there is an existing one
    if (current_allowance.lt(amount) && cBN(amount).gt(0)) {
      if (current_allowance > 0 && requiresResetAllowance.includes(contract._address))
        await approve(contract, 0, account, toContract)
      await approve(contract, currentContract.max_allowance, account, toContract)
    }
  }
}

export async function approveCrossAssetSwaps(address, _amount, underlying_coins = [], toContract, wrapped = false, contract) {

  let contractToken = new currentContract.web3.eth.Contract(ERC20_abi, address)
  var default_account = currentContract.default_account
  var current_allowance = cBN(await contractToken.methods.allowance(default_account, toContract).call());
  var amount = cBN(_amount);


  if (current_allowance.gte(amount))
    return false;
  if ((cBN(_amount).isEqualTo(currentContract.max_allowance)) & (current_allowance.isGreaterThan(currentContract.max_allowance.div(cBN(2)))))
    return false;  // It does get spent slowly, but that's ok
  if ((current_allowance.isGreaterThan(cBN(0))) & (current_allowance.isLessThan(amount)) && requiresResetAllowance.includes(address))
    await approve(contractToken, 0, default_account, toContract);
  return await approve(contractToken, cBN(amount).toFixed(0, 1), default_account, toContract);
}

// XXX not needed anymore
// Keeping for old withdraw, to be removed whenever the chance is
export async function ensure_token_allowance() {
  var default_account = currentContract.default_account
  if (parseInt(await currentContract.swap_token.methods.allowance(default_account, currentContract.swap_address).call()) == 0)
    return new Promise(resolve => {
      currentContract.swap_token.methods.approve(currentContract.swap_address, cBN(currentContract.max_allowance).toFixed(0))
        .send({ from: default_account })
        .once('transactionHash', function(hash) {
          notifyHandler(hash)
          resolve(true);
        })
        .catch(err => {
          errorStore.handleError(err)
        });
    })
  else
    return false;
}

export function init_menu() {
  $("div.top-menu-bar a").toArray().forEach(function(el) {
    if (el.href == window.location.href)
      el.classList.add('selected')
  })
  $('.poolsdropdown .dropdown a').toArray().forEach(function(el) {
    if (el.href.slice(0, -1) == window.location.origin)
      el.classList.add('selected')
  })
}

export async function ensure_stake_allowance(amount, stakeContract, infinite = false) {
  infinite = true;
  var default_account = currentContract.default_account;
  if (!stakeContract) stakeContract = currentContract.curveRewards
  let allowance = cBN(await currentContract.swap_token.methods.allowance(default_account, stakeContract._address).call());
  if (!infinite) {
    if (allowance.lt(amount)) {
      if (allowance.gt(0))
        await approve(currentContract.swap_token, 0, default_account, stakeContract._address)
      await approve(currentContract.swap_token, amount, default_account, stakeContract._address)
    }
  }
  else {
    //if there is an existing allowance which is not infinite then we can still proceed without doing the approval
    if (allowance.lt(amount) && cBN(amount).gt(0)) {
      if (allowance > 0 && requiresResetAllowance.includes(currentContract.swap_token._address))
        await approve(currentContract.swap_token, 0, default_account, stakeContract._address)
      await approve(currentContract.swap_token, currentContract.max_allowance, default_account, stakeContract._address)
    }
  }
}


export function update_rates(version = 'new', contract) {
  if (!contract) contract = currentContract
  let calls = [];
  let callscoins = []
  let abi = contractAbis[contract.currentContract]
  let N_COINS = abi.N_COINS
  if (abi.is_meta)
    N_COINS = abi.meta_N



  for (let i = 0; i < N_COINS; i++) {
    let address = abi.coins[i]
    //  console.log('address', address);
    /*
    rate: uint256 = cERC20(self.coins[i]).exchangeRateStored()
    supply_rate: uint256 = cERC20(self.coins[i]).supplyRatePerBlock()
    old_block: uint256 = cERC20(self.coins[i]).accrualBlockNumber()
    rate += rate * supply_rate * (block.number - old_block) / 10 ** 18
    */
    //for usdt pool
    if (['ankreth'].includes(contract.currentContract)) {
      calls.push(['0xE95A203B1a91a908F9B9CE46459d101078c2c3cb', '0x71ca337d'])
    }
    if (['reth'].includes(contract.currentContract)) {
      calls.push(['0x9559aaa82d9649c7a7b220e7c461d2e74c9a3593', '0xe6aa216c'])
    }

    if (checkTethered(contract, i)) {
      Vue.set(contract.c_rates, i, 1 / abi.coin_precisions[i]);
    }
    else if (['iearn', 'busd', 'susd', 'pax'].includes(contract.currentContract)) {
      if (contract.currentContract == 'susd' && i == 1) {
        calls.push(['0xeDf54bC005bc2Df0Cc6A675596e843D28b16A966', '0xbb7b8b80'])
      }
      else
        //getPricePerFullShare
        calls.push([address, '0x77c7b8fc'])
      callscoins.push({ pool: 'ys', i: i })
    }
    else if (abi.is_meta) {
      //rates for first coin - plain coin so far - is 1 / abi.coin_precisions
      //then add rate for LP token
      //then other coins which are too 1 / abi.coin_precisions

      if (abi.base_pool && abi.base_pool != '3pool') {
        if (i == 1)
          calls.push([contractAbis[abi.base_pool].swap_address, '0xbb7b8b80'])
        else
          Vue.set(contract.c_rates, i, 1 / abi.meta_precisions[i])
      } else {
        if (i == 1)
          calls.push([contractAbis['3pool'].swap_address, '0xbb7b8b80'])
        else
          Vue.set(contract.c_rates, i, 1 / abi.meta_precisions[i])
      }


    }
    else if (abi.is_aave) {

      Vue.set(contract.c_rates, i, 1 / abi.coin_precisions[i]);

    }
    else if (abi.is_idle) {

      //ben_note ==> c_rate (the rate of the underlying should be here)
      //  Vue.set(contract.c_rates, i, 1 / abi.coin_precisions[i]);
      // let idleCoin = new currentContract.web3.eth.Contract(idleERC20_abi, abi.coins[i]);
      // let idleTokenPrice =  idleCoin.methods.tokenPrice().call().then(
      //   Vue.set(contract.c_rates, i, idleTokenPrice / abi.coin_precisions[i] / 1e18)
      // );
      calls.push([address, '0x7ff9b596'])



    }
    else if (['ib'].includes(contract.currentContract)) {

      calls.push(
        //exchangeRateStored
        [address, '0x182df0f5'],
        //supplyRatePerBlock
        [address, '0xae9d70b0'],
        //accrualBlockNumber
        [address, '0x6c540baf'],
      )
      callscoins.push({ pool: 'ib', i: i })

    }
    else {
      calls.push(
        //exchangeRateStored
        [address, '0x182df0f5'],
        //supplyRatePerBlock
        [address, '0xae9d70b0'],
        //accrualBlockNumber
        [address, '0x6c540baf'],
      )
      callscoins.push({ pool: 'compounds', i: i })
    }
  }

  return calls;
}

export async function update_fee_info(version = 'new', contract, update = true) {
  let web3 = currentContract.web3 || new Web3(infura_url)
  if (!contract) contract = currentContract
  var swap_abi_stats = contractAbis[contract.currentContract]?.swap_abi;
  var swap_address_stats = contractAbis[contract.currentContract]?.swap_address;
  var swap_token_stats = contractAbis[contract.currentContract]?.swap_token
  var swap_token_address = contractAbis[contract.currentContract]?.token_address
  var swap_stats = contract.swap;
  var swap_token_stats = contract.swap_token;
  if (version == 'old') {
    swap_abi_stats = contractAbis[contract.currentContract]?.old_swap_abi;
    swap_address_stats = contractAbis[contract.currentContract]?.old_swap_address;
    swap_stats = contract.old_swap;
    swap_token_stats = contract.old_swap_token;
    swap_token_address = contractAbis[contract.currentContract]?.token_address
  }
  var default_account = contract.default_account || '0x0000000000000000000000000000000000000000';
  let calls = [
    //.fee()
    [swap_address_stats, swap_stats.methods.fee().encodeABI()],
    //.admin_fee()
    [swap_address_stats, swap_stats.methods.admin_fee().encodeABI()],
    //balanceOf(default_account)
    [swap_token_address, swap_token_stats.methods.balanceOf(default_account).encodeABI()],
    //token_supply()
    [swap_token_address, swap_token_stats.methods.totalSupply().encodeABI()],
  ]
  let rates_calls = update_rates(version, contract);

  let swap = new web3.eth.Contract(swap_abi_stats, swap_address_stats);
  if (contractAbis[contract.currentContract].REAL_COINS) {
    for (let i = 0; i < contractAbis[contract.currentContract].REAL_COINS; i++) {
      //swap.methods.balances(i)
      calls.push([swap_address_stats, swap.methods.balances(i).encodeABI()])
    }
  } else {
    for (let i = 0; i < contractAbis[contract.currentContract].N_COINS; i++) {
      //swap.methods.balances(i)
      calls.push([swap_address_stats, swap.methods.balances(i).encodeABI()])
    }
  }
  calls.push(...rates_calls)
  //if(['susdv2','sbtc', 'iearn', 'y'].includes(contract.currentContract) && update)
  if (contractAbis[contract.currentContract].gauge_address) {
    calls.push([contractAbis[contract.currentContract].gauge_address, contract.gaugeContract.methods.balanceOf(default_account).encodeABI()])
  }

  if (update)
    await multiInitState(calls, contract)

  return calls
}

function checkTethered(contract, i) {
  return contractAbis[contract.currentContract].tethered && contractAbis[contract.currentContract].tethered[i] &&
    contractAbis[contract.currentContract].use_lending && !contractAbis[contract.currentContract].use_lending[i]
    || contractAbis[contract.currentContract].is_plain[i] || contract.currentContract == 'susdv2';
}

export async function multiInitState(calls, contract, initContracts = false) {
  let web3 = currentContract.web3 || new Web3(infura_url)
  //console.log('Network id',await web3.eth.net.getId());
  let multicall = new web3.eth.Contract(multicall_abi, multicall_address)
  var default_account = currentContract.default_account;
  let aggcalls;

  try {
    aggcalls = await multicall.methods.aggregate(calls).call()

    if (config.blockchainId === 'kava' || config.blockchainId === 'celo') {
      aggcalls = {
        ...aggcalls,
        1: aggcalls[1].map((res) => res === '0x' ? '0x0000000000000000000000000000000000000000000000000000000000000000' : res),
        returnData: aggcalls[1].map((res) => res === '0x' ? '0x0000000000000000000000000000000000000000000000000000000000000000' : res),
      };
    }
  }
  catch (err) {
    // Try calls one by one to see which ones fail
    // if (IS_DEV) {
    //     console.error('multiInitState multicall is failing; until we do a big refactoring of it, here is a one-by-one run of each call to see which one is failing:');
    //     for (const call of calls) {
    //         console.log(`Running call #${calls.indexOf(call)}…`);
    //         try {
    //             await multicall.methods.aggregate([call]).call();
    //             console.log(`Call #${calls.indexOf(call)} ran successfully!`);
    //         } catch (err) {
    //             console.log(`Call #${calls.indexOf(call)} failed!`, { call, err });
    //         }
    //     }
    //     console.error('End of multiInitState multicall debugging.')
    // }

    console.log('Error in multiInitState', calls)
    // Retry the same calls, after stripping out get_virtual_price(), which is the
    // usual culprit if calls revert; then add 0 as virtual price in all the positions
    // it was stripped from. If it still reverts, try after also stripping fee() calls,
    // since if fee is 0 it also reverts.

    const getVirtualPriceSignature = '0xbb7b8b80';
    const feeSignature = '0xddca3f43';

    try {
      const [strippedCalls, virtualPriceCallsIndices] = calls.reduce(([strippedCalls, virtualPriceCallsIndices], call, index) => {
        if (call[1] === getVirtualPriceSignature) {
          return [
            strippedCalls,
            virtualPriceCallsIndices.concat(index),
          ];
        } else {
          return [
            strippedCalls.concat([call]),
            virtualPriceCallsIndices,
          ];
        }
      }, [[], []]);
      aggcalls = await multicall.methods.aggregate(strippedCalls).call()

      if (config.blockchainId === 'kava' || config.blockchainId === 'celo') {
        aggcalls = {
          ...aggcalls,
          1: aggcalls[1].map((res) => res === '0x' ? '0x0000000000000000000000000000000000000000000000000000000000000000' : res),
          returnData: aggcalls[1].map((res) => res === '0x' ? '0x0000000000000000000000000000000000000000000000000000000000000000' : res),
        };
      }

      const results = [...aggcalls[1]];
      const unstrippedResults = new Array(calls.length).fill(null).map((_, i) => (
        virtualPriceCallsIndices.includes(i) ?
          web3.eth.abi.encodeParameter('uint256', cBN(1e18).toFixed(0)) :
          results.shift()
      ));

      aggcalls[1] = unstrippedResults;
    } catch (err) {
      const [strippedCalls, virtualPriceCallsIndices] = calls.reduce(([strippedCalls, virtualPriceCallsIndices], call, index) => {
        if (call[1] === getVirtualPriceSignature || call[1] === feeSignature) {
          return [
            strippedCalls,
            virtualPriceCallsIndices.concat(index),
          ];
        } else {
          return [
            strippedCalls.concat([call]),
            virtualPriceCallsIndices,
          ];
        }
      }, [[], []]);
      aggcalls = await multicall.methods.aggregate(strippedCalls).call()

      const results = [...aggcalls[1]];
      const unstrippedResults = new Array(calls.length).fill(null).map((_, i) => (
        virtualPriceCallsIndices.includes(i) ?
          web3.eth.abi.encodeParameter('uint256', cBN(1e18).toFixed(0)) :
          results.shift()
      ));

      aggcalls[1] = unstrippedResults;
    }
  }

  var block = +aggcalls[0]
  //initContracts && contract.currentContract == 'compound' && i == 0 ||
  let decoded = aggcalls[1].map((hex, i) => {
    return web3.eth.abi.decodeParameter('uint256', hex)
  }
  )

  contract.oldBalance = 0
  if (initContracts) {
    contract.virtual_price = decoded[0] / 1e18;
    contract.A = decoded[1] / 1e18;
    contract.future_A = +decoded[2];
    contract.admin_actions_deadline = +decoded[3];
    decoded = decoded.slice(4);
  }
  if (initContracts && contract.currentContract == 'compound') {
    contract.oldBalance = decoded[0];
    decoded = decoded.slice(1);
  }
  if (initContracts && contract.currentContract == 'susdv2') {
    contract.oldBalance = decoded[0];
    decoded = decoded.slice(1);
  }
  if (initContracts && ['sbtc', 'iearn', 'y'].includes(contract.currentContract)) {
    //decoded = decoded.slice(1);
  }
  if (initContracts) {
    contract.curveStakedBalance = decoded[0]
    decoded = decoded.slice(1)
  }

  const currentPool = pools.getById(contract.currentContract);

  if (initContracts && !currentPool.isOldPool) {
    contract.initial_A = +decoded[0];
    contract.initial_A_time = +decoded[1];
    contract.future_A_time = +decoded[2];
    decoded = decoded.slice(3)
  }
  if (initContracts && contract.is_meta) {
    contract.base_supply = +decoded[0]
    decoded = decoded.slice(1)
  }
  contract.fee = decoded[0] / 1e10;
  contract.admin_fee = decoded[1] / 1e10;
  // it's here that decoded has one too many items, either don't push it in the first place or just slice here
  var token_balance = decoded[2]
  var token_supply = decoded[3]
  contract.totalBalance = token_balance
  contract.totalSupply = token_supply
  let ratesDecoded = decoded.slice(4 + contractAbis[contract.currentContract].N_COINS)

  if (currentPool.cryptoPool) {
    const decodedCryptoPoolsData = await callCryptoPoolData(contract.currentContract);

    let getOracles = decodedCryptoPoolsData
    //coin 0 is ignored because it's a dollar, Im not sure if it always will be
    let precisionkey = 1
    for (var i = 0; i < (contractAbis[contract.currentContract].N_COINS - 1) * 2; i++) {
      let divider = contractAbis[contract.currentContract].coin_precisions[precisionkey]
      divider = getDecimalsFromPow(divider)
      contract.priceOracle[precisionkey - 1] = getOracles[i] / 10 ** 18
      i++
      contract.priceScale[precisionkey - 1] = getOracles[i] / 10 ** 18
      precisionkey++
    }

    //remove price stuff and move to gammas
    // Number of actual coins in pool minus 1
    let nCoinsGamma = (contractAbis[contract.currentContract].REAL_COINS || contractAbis[contract.currentContract].N_COINS) - 1

    let gammas = getOracles.slice((nCoinsGamma) * 2)
    contract.initial_A_gamma = gammas[0]
    contract.future_A_gamma = gammas[1]

  }

  if (initContracts) {
    // let contractsDecoded = decoded.slice(-contractAbis[contract.currentContract].N_COINS*2)
    // chunkArr(contractsDecoded, 2).map((v, i) => {
    //     var addr = v[0];
    //     var underlying_addr = v[1];
    //     let coin_abi = cERC20_abi
    //     var underlying_addr = v[1];
    //     let underlying_abi = ERC20_abi
    //     if(contract.currentContract == 'susdv2' && i == 3 || contract.currentContract == 'sbtc' && i == 2) {
    //         coin_abi = synthERC20_abi
    //         underlying_abi = synthERC20_abi
    //     }
    //     if(['iearn', 'busd', 'susd', 'pax'].includes(contract.currentContract)) coin_abi = yERC20_abi
    //     contract.coins.push(new web3.eth.Contract(coin_abi, addr));
    //     contract.underlying_coins.push(new web3.eth.Contract(underlying_abi, underlying_addr));
    // })
    // TODO post-refactoring
    // Refactor this too, detect isSynth; perhaps even ABI field to coins config, and match
    // coin on address, so the mapping coin<>abi can be reused everywhere!
    contract.coins = Array.from(Array(contractAbis[contract.currentContract].N_COINS), (_, i) => {
      let coin_abi = cERC20_abi
      let coin_address = contractAbis[contract.currentContract].coins[i]
      if (contract.currentContract == 'susdv2' && i == 3
        || contract.currentContract == 'sbtc' && i == 2
        || contract.currentContract == 'tbtc' && i == 3
        || contract.currentContract == 'pbtc' && i == 3
        || contract.currentContract == 'bbtc' && i == 3
        || contract.currentContract == 'obtc' && i == 3
        || contract.currentContract == 'eurs' && i == 1
        || contract.currentContract == 'eurt' && i == 1

        || contract.currentContract == 'seth' && i == 1
        || contract.currentContract == 'saave' && i == 1
        || contract.currentContract == 'link' && i == 1) {
        coin_abi = synthERC20_abi
      }

      if (['idle'].includes(contract.currentContract)) coin_abi = idleERC20_abi
      return new web3.eth.Contract(coin_abi, coin_address)

      if (['ib'].includes(contract.currentContract)) coin_abi = cERC20_abi
      return new web3.eth.Contract(coin_abi, coin_address)

      if (['iearn', 'busd', 'susd', 'pax'].includes(contract.currentContract)) coin_abi = yERC20_abi
      return new web3.eth.Contract(coin_abi, coin_address)
    })
    contract.underlying_coins = Array.from(Array(contractAbis[contract.currentContract].N_COINS), (_, i) => {
      let underlying_abi = ERC20_abi
      let underlying_address = contractAbis[contract.currentContract].underlying_coins[i]
      if (contract.currentContract == 'susdv2' && i == 3
        || contract.currentContract == 'sbtc' && i == 2
        || contract.currentContract == 'tbtc' && i == 3
        || contract.currentContract == 'pbtc' && i == 3
        || contract.currentContract == 'bbtc' && i == 3
        || contract.currentContract == 'obtc' && i == 3
        || contract.currentContract == 'eurs' && i == 1
        || contract.currentContract == 'seth' && i == 1
        || contract.currentContract == 'saave' && i == 1
        || contract.currentContract == 'link' && i == 1) {
        underlying_abi = synthERC20_abi
      }
      return new web3.eth.Contract(underlying_abi, underlying_address)
    })
    if (contractAbis[contract.currentContract].is_meta) {
      contract.all_coins = Array.from(Array(contractAbis[contract.currentContract].meta_N), (_, i) => {
        let coinabi = ERC20_abi
        if (contract.currentContract == 'tbtc' && i == 4 || contract.currentContract == 'pbtc' && i == 4
          || contract.currentContract == 'bbtc' && i == 4
          || contract.currentContract == 'obtc' && i == 4
          || contract.currentContract == 'seth' && i == 1
          || contract.currentContract == 'eurs' && i == 1
          || contract.currentContract == 'saave' && i == 1
          || contract.currentContract == 'link' && i == 1)
          coinabi = synthERC20_abi
        return new web3.eth.Contract(coinabi, contractAbis[contract.currentContract].all_coins[i])
      })
    }
    ratesDecoded = decoded.slice(4 + contractAbis[contract.currentContract].N_COINS)
  }



  if (['iearn', 'busd', 'susd', 'pax'].includes(contract.currentContract)) {
    ratesDecoded.map((v, i) => {
      if (checkTethered(contract, i)) {
        let rate = 1 / contractAbis[contract.currentContract].coin_precisions[i]
        Vue.set(contract.c_rates, i, rate);
      }
      else {
        let rate = v / 1e18 / contractAbis[contract.currentContract].coin_precisions[i]
        if (contract.currentContract == 'susd' && i == 1) rate = v / 1e36
        Vue.set(contract.c_rates, i, rate)
      }
    })
  }
  else if (contract.is_meta) {
    ratesDecoded.map((v, i) => {
      if (i != 1) {
        Vue.set(contract.c_rates, i, 1 / contractAbis[contract.currentContract].meta_precisions[i]);
      }
      else {
        let rate = v / 1e36
        Vue.set(contract.c_rates, i, rate)
      }
    })
  }
  else if (contract.currentContract == 'geist' || contract.currentContract == 'aave' || contract.currentContract == 'saave'
    || (contract.currentContract == 'ren' && config.blockchainId === 'polygon')
    || (contract.currentContract == 'ren' && config.blockchainId === 'avalanche')
    || (contract.currentContract == 'aaveV3' && config.blockchainId === 'avalanche')
  ) {

    contract.c_rates.map((rate, i) => {
      Vue.set(contract.c_rates, i, 1 / contract.wrapped_precisions[i])
    })


  }
  else if (contract.currentContract == 'ankreth') {
    ratesDecoded.map((v, i) => {
      if (i !== 1) {
        Vue.set(contract.c_rates, i, 1 / 1e18)
      } else {
        Vue.set(contract.c_rates, i, 1 / v)
      }
    })


  }
  else if (contract.currentContract == 'reth') {
    ratesDecoded.map((v, i) => {
      if (i !== 1) {
        Vue.set(contract.c_rates, i, 1 / 1e18)
      } else {
        Vue.set(contract.c_rates, i, v / 1e36)
      }
    })


  }
  else if (contract.currentContract == 'idle') {

    //ben_note the rate of the underlying should also be here
    ratesDecoded.map((v, i) => {
      Vue.set(contract.c_rates, i, v / contractAbis[contract.currentContract].coin_precisions[i] / 1e18);
    })



  } else {

    chunkArr(ratesDecoded, 3).map((v, i) => {
      if (checkTethered(contract, i) || contract.currentContract == 'susdv2') {
        let rate = 1 / contractAbis[contract.currentContract].coin_precisions[i]
        Vue.set(contract.c_rates, i, rate);
      }
      else {
        //console.log(v, 'vv')
        let rate = +v[0] / 1e18 / contractAbis[contract.currentContract].coin_precisions[i]
        let supply_rate = +v[1]
        let old_block = +v[2]

        if (contract.currentContract === 'ib' && config.blockchainId === 'fantom') {
          block = Date.now() / 1000 | 0
        }

        let cRate = rate * (1 + supply_rate * (block - old_block) / 1e18)
        //console.log(cRate, 'cRate');
        Vue.set(contract.c_rates, i, cRate)
      }
    })
  }

  //console.log('contract.c_rates',contract.c_rates);

  let balances = []
  currentContract.total = 0;

  if (contract.currentContract === 'atricrypto' || contract.currentContract === 'atricrypto2' || contract.currentContract === 'atricrypto3') {

    let version = contract.currentContract === 'atricrypto' ? 1 : contract.currentContract === 'atricrypto2' ? 2 : 3


    await initATriCrypto(contract, version);
  } else {
    let balancesDecoded = decoded.slice(4, 4 + contractAbis[contract.currentContract].N_COINS)
    balancesDecoded.forEach((balance, i) => {
      Vue.set(contract.balances, i, +balance)
      balances[i] = +balance;
      if (contract.currentContract !== 'atricrypto' && contract.currentContract !== 'atricrypto2' && contract.currentContract !== 'atricrypto3') {
        Vue.set(contract.bal_info, i, balances[i] * contract.c_rates[i]);
      }

      contract.total += balances[i] * contract.c_rates[i];
    })
  }

  if (!initContracts)
    contract.curveStakedBalance = decoded[decoded.length - 1]

  if (default_account && contract.currentContract !== 'atricrypto' && contract.currentContract !== 'atricrypto2' && contract.currentContract !== 'atricrypto3') {
    if (token_balance > 0) {
      contract.totalShare = 0;
      for (let i = 0; i < contract.N_COINS; i++) {
        var val = balances[i] * contract.c_rates[i] * token_balance / token_supply;
        contract.totalShare += val;
        Vue.set(contract.l_info, i, val)
      }

      if (currentPool.cryptoPool) {
        const tokenPrices = await getPricesArrayForTokens(currentPool.coins.map(({ address }) => address));

        let totalBalance = 0;
        for (let i = 0; i < contract.N_COINS; i++) {
          var val = balances[i] * contract.c_rates[i] * token_balance / token_supply;
          totalBalance += val * tokenPrices[i];
        }

        contract.usdShare = totalBalance;
      } else {
        contract.usdShare = token_balance * contract.virtual_price / 1e18;
      }

      contract.showShares = true;
    }
    else {
      contract.totalShare = 0;
      contract.usdShare = 0
      contract.showShares = false;
      //no need to set other values as v-show check is done based on totalShare
    }

    contract.totalStake = 0;
    if (contract.curveStakedBalance > 0) {
      contract.staked_info = new Array(contract.N_COINS).fill(0)

      if (currentPool.cryptoPool) {
        const tokenPrices = await getPricesArrayForTokens(currentPool.coins.map(({ address }) => address));
        console.log({
          tokenPrices,
          balances,
        })

        let totalBalance = 0;
        for (let i = 0; i < contract.N_COINS; i++) {
          var val = balances[i] * contract.c_rates[i] * contract.curveStakedBalance / token_supply;
          totalBalance += val * tokenPrices[i];
          Vue.set(contract.staked_info, i, val)
          contract.totalStake += val;
        }

        contract.usdStake = totalBalance;
      } else {
        for (let i = 0; i < contract.N_COINS; i++) {
          var val = balances[i] * contract.c_rates[i] * contract.curveStakedBalance / token_supply;
          Vue.set(contract.staked_info, i, val)
          contract.totalStake += val;
        }
        contract.usdStake = contract.curveStakedBalance * contract.virtual_price / 1e18;
      }
    }
    EventBus.$emit('updateShares')
  }
}

const getAtricryptoInfo = memoize(async (version, providedUserAddress) => {
  let web3 = currentContract.web3 || new Web3(infura_url)
  let poolId = version === 1 ? 'atricrypto' : 'atricrypto2';
  if (version == 3) {
    poolId = 'atricrypto3'
  }
  const pool = pools.getById(poolId);
  console.log({ pool })
  const basePool = pools.getById(config.blockchainId !== 'harmony' ? 'aave' : '3pool');

  const poolAbiData = contractAbis[poolId];
  const basePoolAbiData = contractAbis[config.blockchainId !== 'harmony' ? 'aave' : '3pool'];

  const userAddress = providedUserAddress || currentContract.default_account || '0x0000000000000000000000000000000000000000';
  const baseSwapTokenContract = new web3.eth.Contract(ERC20_abi, basePool.addresses.lpToken)
  const swapTokenContract = new web3.eth.Contract(ERC20_abi, pool.addresses.lpToken)
  const baseSwapContract = new web3.eth.Contract(basePoolAbiData.swap_abi, basePool.addresses.swap)
  const swapContract = new web3.eth.Contract(poolAbiData.swap_abi, pool.addresses.swap)
  const gaugeContract = new web3.eth.Contract(liquiditygauge_v3, pool.addresses.gauge)

  const callsConfig = [
    ...pool.coins.map(({ address }) => ({
      contract: new web3.eth.Contract(ERC20_abi, address),
      methodName: 'balanceOf',
      params: [userAddress],
    })),
    {
      contract: swapTokenContract,
      methodName: 'balanceOf',
      params: [userAddress],
    },
    ...[0, 1, 2].map((balanceIndex) => ({
      contract: baseSwapContract,
      methodName: 'balances',
      params: [balanceIndex],
    })),
    ...[0, 1, 2].map((balanceIndex) => ({
      contract: swapContract,
      methodName: 'balances',
      params: [balanceIndex],
    })),
    {
      contract: baseSwapTokenContract,
      methodName: 'totalSupply',
    },
    {
      contract: swapTokenContract,
      methodName: 'totalSupply',
    },
    {
      contract: gaugeContract,
      methodName: 'balanceOf',
      params: [userAddress],
    },
  ];

  const decoded = await multiCall(callsConfig);

  const userBalances = decoded.slice(0, pool.coins.length);
  const userLpTokenBalance = decoded.slice(pool.coins.length, pool.coins.length + 1)[0];
  const baseSwapBalances = decoded.slice(pool.coins.length + 1, pool.coins.length + 4);
  const swapBalances = decoded.slice(pool.coins.length + 4, pool.coins.length + 7);
  const baseTokenTotalSupply = decoded.slice(pool.coins.length + 7, pool.coins.length + 8)[0];
  const swapTokenTotalSupply = decoded.slice(pool.coins.length + 8, pool.coins.length + 9)[0];
  const userStakedBalance = decoded.slice(pool.coins.length + 9, pool.coins.length + 10)[0];

  const coinPrecisions = contractAbis[pool.id].coin_precisions;
  const wrappedPrecisions = contractAbis[pool.id].wrapped_precisions;

  // userBalances.map((v, i) => {
  //     Vue.set(this.wallet_balances, i, +v / coinPrecisions[i])
  // });

  const totalContractBalances = [
    ...baseSwapBalances.map((balance, i) => {
      const underlyingPoolLpTokenBalance = swapBalances[0];
      const poolShareOfUnderlyingPool = underlyingPoolLpTokenBalance / baseTokenTotalSupply;

      const totalBalance = balance / coinPrecisions[i];
      return totalBalance * poolShareOfUnderlyingPool;
    }),
    ...swapBalances.slice(1).map((swapBalance, i) => {
      const wrappedPrecisionsIndex = i + 1;
      return swapBalance / wrappedPrecisions[wrappedPrecisionsIndex];
    }),
  ];

  const userShareOfPool = userLpTokenBalance / swapTokenTotalSupply;
  const userStakedShareOfPool = userStakedBalance / swapTokenTotalSupply;

  const [userContractBalances, userStakedContractBalances] = [userShareOfPool, userStakedShareOfPool].map(((userShare) => [
    ...baseSwapBalances.map((balance, i) => {
      const underlyingPoolLpTokenBalance = swapBalances[0];
      const poolShareOfUnderlyingPool = underlyingPoolLpTokenBalance / baseTokenTotalSupply;

      const totalBalance = balance / coinPrecisions[i];
      const userBalance = totalBalance * userShare * poolShareOfUnderlyingPool;
      return userBalance;
    }),
    ...swapBalances.slice(1).map((balance, i) => {
      const wrappedPrecisionsIndex = i + 1;
      const totalBalance = balance / wrappedPrecisions[wrappedPrecisionsIndex];
      const userBalance = totalBalance * userShare;
      return userBalance;
    }),
  ]));

  const tokenPrices = await getPricesArrayForTokens(pool.coins.map(({ address }) => address));
  const totalContractBalancesUsd = sum(totalContractBalances.map((amount, i) => (
    amount * tokenPrices[i]
  )));
  const totalUserContractBalancesUsd = sum(userContractBalances.map((amount, i) => (
    amount * tokenPrices[i]
  )));
  const totalUserStakedContractBalancesUsd = sum(userStakedContractBalances.map((amount, i) => (
    amount * tokenPrices[i]
  )));

  return {
    userStakedBalance,
    userShareOfPool,
    userStakedShareOfPool,
    totalContractBalances,
    userContractBalances,
    userStakedContractBalances,
    tokenPrices,
    totalContractBalancesUsd,
    totalUserContractBalancesUsd,
    totalUserStakedContractBalancesUsd,
    userLpTokenBalance,
    swapTokenTotalSupply,
  };
}, {
  promise: true,
  maxAge: 10 * 1000, // 10s
});

async function initATriCrypto(contract, version = 1) {
  const {
    userStakedBalance,
    userShareOfPool,
    totalContractBalances,
    userContractBalances,
    userStakedContractBalances,
    totalContractBalancesUsd,
    totalUserContractBalancesUsd,
    totalUserStakedContractBalancesUsd,
  } = await getAtricryptoInfo(version);

  totalContractBalances.forEach((balance, i) => {
    Vue.set(contract.bal_info, i, balance);
  });

  userContractBalances.forEach((balance, i) => {
    Vue.set(contract.l_info, i, balance);
  });

  if (userStakedContractBalances.length && !contract.staked_info) {
    contract.staked_info = new Array(contract.N_COINS).fill(0)
  }
  userStakedContractBalances.forEach((balance, i) => {
    Vue.set(contract.staked_info, i, balance);
  });

  contract.total = totalContractBalancesUsd;
  contract.usdShare = totalUserContractBalancesUsd;
  contract.totalShare = userShareOfPool;

  contract.curveStakedBalance = userStakedBalance;
  contract.usdStake = totalUserStakedContractBalancesUsd;
  contract.totalStake = totalUserStakedContractBalancesUsd;
}

export async function handle_migrate_new(page) {
  var default_account = currentContract.default_account
  let migration = new currentContract.web3.eth.Contract(contractAbis.compound.migration_abi, currentContract.migration_address);
  let old_balance = await currentContract.old_swap_token.methods.balanceOf(default_account).call();
  var allowance = parseInt(await currentContract.old_swap_token.methods.allowance(default_account, currentContract.migration_address).call());
  if (allowance < old_balance) {
    if (allowance > 0)
      await approve_to_migrate(0, default_account);
    await approve_to_migrate(old_balance, default_account);
  }
  await (await sendSafe(migration.methods.migrate(), {
    from: default_account,
    gas: 1500000,
  })).pe
    .once('transactionHash', hash => {
      notifyHandler(hash)
    })
    .catch(err => {
      errorStore.handleError(err)
    });

  await update_balances();
  update_fee_info(page);
}

// Those pools have two meta pools in them, they need special treatment
const calc_slippage_cryptofactometa_deposit = async ({ values, currentPool }) => {
  const poolCoins = [
    ...currentPool.coins.slice(0, -1),
    ...currentPool.metaCoins,
  ];

  const numberValues = values.map((value) => Number(value) || 0);
  const rawValues = numberValues.map((value, i) => (BigNumber(value).times(poolCoins[i].decimals > 18 ? poolCoins[i].decimals : (10 ** poolCoins[i].decimals)).toFixed()));
  const token_amount = await currentContract.deposit_zap.methods.calc_token_amount(
    contractAbis[currentContract.currentContract].swap_address,
    rawValues
  ).call();

  const inputBalancesUsd = numberValues.map((amount, i) => (
    amount * poolCoins[i].usdPrice
  ));

  const totalPoolBalancesUsdBefore = currentPool.usdTotal;
  const totalInputBalancesUsd = sum(inputBalancesUsd);
  const totalPoolBalancesUsdAfter = totalPoolBalancesUsdBefore + totalInputBalancesUsd;

  const lpTokenAmount = token_amount / 1e18;
  const lpTokenTotalSupply = currentPool.totalSupply / 1e18;

  const depositValueAfter = BigNumber(totalPoolBalancesUsdAfter).times(lpTokenAmount).div(lpTokenTotalSupply + lpTokenAmount);

  const slippage = depositValueAfter.div(totalInputBalancesUsd).minus(1).toNumber();

  currentContract.slippage = slippage;
  currentContract.showSlippage = true;
};

export async function calc_slippage(values, deposit, zap_values, to_currency, isWithdrawal, withdrawShare) {
  const areAllValuesEmpty = (
    (values || []).every((n) => Number(n) === 0) &&
    (zap_values || []).every((n) => Number(n) === 0)
  );
  if (areAllValuesEmpty) return; // No need to calc slippage if all values empty

  const currentPool = pools.getById(currentContract.currentContract);
  const isFactoCryptoMetaPool = (
    contractAbis[currentContract.currentContract].is_meta &&
    contractAbis[currentContract.currentContract].is_factory &&
    contractAbis[currentContract.currentContract].pool_type === 'crypto'
  );

  try {
    if (typeof isWithdrawal === 'undefined') isWithdrawal = false; // Can't use default values in function sig
    if (typeof withdrawShare === 'undefined') withdrawShare = undefined; // Can't use default values in function sig
    let tokenBurnAmount;

    if (isFactoCryptoMetaPool && deposit) {
      await calc_slippage_cryptofactometa_deposit({ values, currentPool });
      return;
    }

    //var real_values = [...$("[id^=currency_]")].map((x,i) => +($(x).val()));
    let calcContractName = 'swap';
    const abiData = contractAbis[currentContract.currentContract];
    let is_meta = abiData.is_meta
    let c_rates = currentContract.c_rates
    //maybe check if you're depositing wrapped or not?
    values = values.map(v => v || 0)
    if (is_meta) {
      if (values.length == abiData.meta_N - 1) {
        calcContractName = 'deposit_zap';
        c_rates = c_rates.filter((_, i) => i != 1)
      }
    }


    if (currentPool.isFakePlainPool) {
      calcContractName = 'crypto_zap';
    }


    let slippage = 0;
    var real_values = Array(values.length).fill(0)
    let calls = [
      [currentContract.swap._address, currentContract.swap.methods.get_virtual_price().encodeABI()],
    ]
    let hasSpecialEmptyValuesHandlingKickedIn = false;

    if (to_currency !== undefined) {
      let precision = contractAbis[currentContract.currentContract].coin_precisions[to_currency]
      if (is_meta && zap_values.length == abiData.meta_N) {
        calcContractName = 'deposit_zap';
        precision = contractAbis[currentContract.currentContract].meta_precisions[to_currency]
      }
      if (is_meta && zap_values.length == 2)
        precision = contractAbis[currentContract.currentContract].meta_wrapped_precisions[to_currency]
      real_values[to_currency] = zap_values[to_currency].div(precision)
      zap_values[to_currency] = zap_values[to_currency].times(1e18 / precision)
      let real_to_currency = to_currency
      // if(is_meta && zap_values.length == 5 && real_to_currency > 0)
      //     real_to_currency += 1
      var Sr = zap_values[real_to_currency]
      zap_values[real_to_currency] = zap_values[real_to_currency].div(1e18).div(currentContract.c_rates[real_to_currency]).toFixed(0);

      if (is_meta && zap_values.length == abiData.meta_N)
        zap_values = zap_values.filter((_, i) => i != 1)

      if (contractAbis[currentContract.currentContract].is_factory && zap_values.length == (abiData.meta_N - 1)) {
        const methodName = isWithdrawal ? 'calc_withdraw_one_coin' : 'calc_token_amount';

        if (calcContractName === 'swap' && methodName === 'calc_withdraw_one_coin') {
          tokenBurnAmount = await currentContract[calcContractName].methods.balanceOf(currentContract.default_account).call();
        }

        if (calcContractName === 'deposit_zap' && methodName === 'calc_withdraw_one_coin') {
          const [lpTokenBalance] = await multiCall([{
            address: contractAbis[currentContract.currentContract].swap_address,
            abi: ERC20_abi,
            methodName: 'balanceOf',
            params: [currentContract.default_account],
          }]);

          const withdrawRatio = withdrawShare / 100;
          tokenBurnAmount = withdrawRatio < 1 ?
            BigNumber(lpTokenBalance).times(withdrawShare / 100).toNumber() :
            lpTokenBalance;

          const needToOffsetToCurrencyIndex = is_meta && to_currency > 0;
          to_currency = needToOffsetToCurrencyIndex ? (to_currency - 1) : to_currency;
        }

        const calcArgs = (
          (contractAbis[currentContract.currentContract].pool_type === 'crypto') ? [
            tokenBurnAmount,
          ] :
            (calcContractName === 'swap' && methodName === 'calc_withdraw_one_coin') ? [
              tokenBurnAmount,
              to_currency,
            ] :
              (calcContractName === 'swap' && methodName !== 'calc_withdraw_one_coin') ? [
                zap_values,
                to_currency,
              ] :
                [
                  contractAbis[currentContract.currentContract].swap_address,
                  tokenBurnAmount,
                  to_currency,
                ]
        );

        calls.push([
          currentContract[calcContractName]._address,
          currentContract[calcContractName].methods[methodName](...calcArgs).encodeABI(),
        ]);
      } else {
        calls.push([
          currentContract[calcContractName]._address,
          currentContract[calcContractName].methods.calc_token_amount(zap_values, to_currency).encodeABI(),
        ]);
      }
    }
    else {
      real_values = values.map(v => +v);
      var Sr = real_values.reduce((a, b) => a + b, 0);

      var values = real_values.map((x, i) => cBN(Math.floor(x / c_rates[i]).toString()).toFixed(0, 1));
      if (contractAbis[currentContract.currentContract].is_factory) {
        const calcArgs = (
          (contractAbis[currentContract.currentContract].pool_type === 'crypto') ? [
            values
          ] : calcContractName === 'swap' ? [
            values,
            deposit,
          ] : [
            contractAbis[currentContract.currentContract].swap_address,
            values,
            deposit,
          ]
        );

        calls.push([currentContract[calcContractName]._address, currentContract[calcContractName].methods.calc_token_amount(...calcArgs).encodeABI()])
      } else {
        if (currentPool.isForexMetaPool || currentPool.isPlainCryptoPool) {
          // Replace all zero values with 1 wei, because some contracts (at least eursusd) revert when
          // called with zero values. And flag that we've done so so we can set token_amount to 0 manually.
          const areValuesAllZero = values.every((val) => val === '0');
          if (areValuesAllZero) {
            hasSpecialEmptyValuesHandlingKickedIn = true;
            values = values.map(() => '1');
          }
          calls.push([currentContract[calcContractName]._address, currentContract[calcContractName].methods.calc_token_amount(values).encodeABI()])
        } else {
          calls.push([currentContract[calcContractName]._address, currentContract[calcContractName].methods.calc_token_amount(values, deposit).encodeABI()])
        }
      }
    }

    if (!currentPool.isFakePlainPool && !isFactoCryptoMetaPool) {
      calls.push(...[...Array(values.length).keys()].map(i => [currentContract.swap._address, currentContract.swap.methods.balances(i).encodeABI()]))
      if (is_meta && ((values && values.length == abiData.meta_N - 1) || (zap_values && zap_values.length) == abiData.meta_N - 1)) {
        calls = calls.slice(0, 2)
        calls.push([currentContract.swap._address, currentContract.swap.methods.balances(0).encodeABI()])
        calls.push(...Array.from(Array(contractAbis[currentContract.currentContract].meta_N - currentContract.N_COINS), (_, i) => [currentContract.base_swap._address, currentContract.base_swap.methods.balances(i).encodeABI()]))
      }
    }

    let aggcalls = await currentContract.multicall.methods.aggregate(calls).call();
    let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
    let [virtual_price, token_amount, ...balances] = decoded
    if (hasSpecialEmptyValuesHandlingKickedIn) token_amount = 0;

    if ((currentPool.cryptoPool || currentPool.isStablePoolWithSpecialUnpeggedAssets) && deposit) {
      let metaLpTokenBalance;
      let baseLpTokenTotalSupply;
      let poolCoins = currentPool.coins;
      const isMetaPoolHandlingUnwrappedTokens = (
        currentPool.isMetaPool &&
        values.length === (currentPool.metaCoins.length + 1)
      );
      if (isMetaPoolHandlingUnwrappedTokens && !isFactoCryptoMetaPool) {
        const lpTokenBase = poolCoins.find(({ isLpToken }) => isLpToken);
        const basePool = pools.find(({ addresses: { lpToken } }) => lpToken.toLowerCase() === lpTokenBase.address.toLowerCase());

        poolCoins = [
          ...poolCoins.filter(({ id }) => id !== lpTokenBase.id),
          ...basePool.coins,
        ];

        const metaInfo = await multiCall([{
          contract: currentContract.swap,
          methodName: 'balances',
          params: [1],
        }, {
          contract: currentContract.base_token,
          methodName: 'totalSupply',
        }]);
        metaLpTokenBalance = metaInfo[0] / 1e18;
        baseLpTokenTotalSupply = metaInfo[1] / 1e18;
        const metaPoolBaseLpTokenShare = metaLpTokenBalance / baseLpTokenTotalSupply;

        // For crypto meta pools, update balances so they represent the pool's own share of the base pool's assets
        balances = [
          balances[0],
          ...balances.slice(1).map((balance) => balance * metaPoolBaseLpTokenShare),
        ];
      }
      const poolBalances = currentPool.isFakePlainPool ? undefined : balances;
      const inputBalances = hasSpecialEmptyValuesHandlingKickedIn ? values.map(() => 0) : values;
      const lpTokenAmount = token_amount / 1e18;
      const lpTokenTotalSupply = (await currentContract.swap_token.methods.totalSupply().call()) / 1e18;
      const tokenPrices = await getPricesArrayForTokens(poolCoins.map(({ address }) => address));

      const poolBalancesUsd = currentPool.isFakePlainPool ?
        undefined :
        poolBalances.map((amount, i) => (
          amount / (poolCoins[i].decimals < 100 ? (10 ** poolCoins[i].decimals) : poolCoins[i].decimals) * tokenPrices[i]
        ));

      const inputBalancesUsd = inputBalances.map((amount, i) => (
        amount / (poolCoins[i].decimals < 100 ? (10 ** poolCoins[i].decimals) : poolCoins[i].decimals) * tokenPrices[i]
      ));

      const totalPoolBalancesUsdBefore = currentPool.isFakePlainPool ?
        (await getAtricryptoInfo(currentPool.id === 'atricrypto' ? 1 : currentPool.id === 'atricrypto2' ? 2 : 3)).totalContractBalancesUsd :
        sum(poolBalancesUsd);
      const totalInputBalancesUsd = sum(inputBalancesUsd);
      const totalPoolBalancesUsdAfter = totalPoolBalancesUsdBefore + totalInputBalancesUsd;

      const depositValueAfter = (currentPool.isMetaPool && currentPool.cryptoPool) ?
        BigNumber(totalPoolBalancesUsdAfter).times(lpTokenAmount).div(lpTokenTotalSupply + lpTokenAmount) :
        BigNumber(totalPoolBalancesUsdAfter).times(lpTokenAmount).div(lpTokenTotalSupply + lpTokenAmount);

      const slippage = depositValueAfter.div(totalInputBalancesUsd).minus(1).toNumber();

      currentContract.slippage = slippage;
      currentContract.showSlippage = true;
    } else {
      if (is_meta) {
        if (real_values && real_values.length == 2 || zap_values && zap_values.length == 2) {
          if (real_values[1])
            real_values[1] *= await currentContract.base_swap.methods.get_virtual_price().call() / 1e18
          Sr = real_values.reduce((a, b) => a + b, 0)
        }

      }
      let Sv = +virtual_price * (+token_amount) / 1e36;
      for (let i = 0; i < values.length; i++) {
        let coin_balance = +balances[i] * c_rates[i];
        if (!deposit) {
          if (coin_balance < real_values[i]) {
            currentContract.showNoBalance = true;
            currentContract.noBalanceCoin = i;
          }
          else
            currentContract.showNoBalance = false;
        }
      }

      if (isWithdrawal && typeof tokenBurnAmount !== 'undefined') {
        Sv = (Number(virtual_price) / 1e18) * (Number(tokenBurnAmount) / 1e18);
        slippage = Sr / (Sv * 1e18);
      } else if (deposit) {
        slippage = Sv / Sr
      } else if (to_currency === undefined) {
        slippage = Sr / Sv;
      } else {
        slippage = Sr / (Sv * 1e18)
      }

      if (!deposit && is_meta && (real_values && real_values.length == 2 || zap_values && zap_values.length == 2))
        slippage = Sr / Sv
      slippage = slippage - 1;
      slippage = slippage || 0
      currentContract.slippage = slippage;
      currentContract.showSlippage = true;
    }
  } catch (err) {
    currentContract.slippage = 'error';
    currentContract.showSlippage = true;
  }
}

// Withdraw slippage calculation for fake plain crypto pools (should work w/ any crypto pool, with little if any adjustment)
export async function calc_slippage_fakeplainpool({
  values,
  userContractBalances,
  userStakedContractBalances,
  withdrawPcent,
  isFactoCryptoMetaPool,
}) {
  const currentPool = pools.getById(currentContract.currentContract);
  let poolCoins = currentPool.coins;

  const isMetaPoolHandlingWrappedTokens = (
    currentPool.isMetaPool &&
    values.length !== (currentPool.coins.length + currentPool.metaCoins.length)
  );

  if (isFactoCryptoMetaPool) {
    poolCoins = [
      ...currentPool.coins.slice(0, -1),
      ...currentPool.metaCoins,
    ];
  } else if (currentPool.isMetaPool) {
    // Remove base lp token balance
    if (!isMetaPoolHandlingWrappedTokens) {
      values = [values[0], ...values.slice(2)];
    }

    const lpTokenBase = poolCoins.find(({ isLpToken }) => isLpToken);
    const basePool = pools.find(({ addresses: { lpToken } }) => lpToken.toLowerCase() === lpTokenBase.address.toLowerCase());

    poolCoins = [
      ...poolCoins.filter(({ id }) => id !== lpTokenBase.id),
      ...basePool.coins,
    ];
  }

  const tokenPrices = (
    isFactoCryptoMetaPool ? (
      poolCoins.map(({ usdPrice }) => usdPrice)
    ) : currentPool.isFactoryOnlyPool ? (
      currentPool.coins.map(({ usdPrice }) => usdPrice)
    ) : currentPool.cryptoPool ? (
      await getPricesArrayForTokens(currentPool.coins.map(({ address }) => address))
    ) : (
      await getPricesForAssets(poolCoins.map((coin) => coin.getCoingeckoId)) // will not work in its current state
    )
  );

  const userBalancesUsd = userContractBalances.map((amount, i) => (
    (Number(amount) + (userStakedContractBalances?.[i] || 0)) * tokenPrices[i]
  ));

  const totalUserBalancesUsdBefore = sum(userBalancesUsd);

  const userBalancesUsdAfterWithdrawal = totalUserBalancesUsdBefore * (1 - (withdrawPcent / 100));
  const outputBalancesUsd = values.map((amount, i) => {
    const precision = (
      currentPool.isMetaPool ?
        (poolCoins[i].decimals < 100 ? (10 ** poolCoins[i].decimals) : poolCoins[i].decimals) :
        contractAbis[currentContract.currentContract].coin_precisions[i]
    );
    const amountNumber = typeof amount === BigNumber ? amount.toNumber() : amount;
    return amountNumber / precision * tokenPrices[i];
  });

  const totalOutputBalancesUsd = sum(outputBalancesUsd);
  const totalUserBalancesUsdAfter = userBalancesUsdAfterWithdrawal + totalOutputBalancesUsd;

  const slippage = (totalUserBalancesUsdAfter / totalUserBalancesUsdBefore) - 1;

  currentContract.slippage = slippage;
  currentContract.showSlippage = true;
}

export async function setTimeout(timeout) {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export { getAtricryptoInfo };
